import { jsx as e } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2097 2.27991C13.5298 2.37314 13.75 2.66655 13.75 3V9.25001L18 9.25001C18.2737 9.25001 18.5257 9.39914 18.6575 9.6391C18.7892 9.87906 18.7797 10.1717 18.6327 10.4027L11.6327 21.4027C11.4537 21.684 11.1105 21.8133 10.7903 21.7201C10.4702 21.6269 10.25 21.3335 10.25 21L10.25 14.75H6C5.72626 14.75 5.47427 14.6009 5.34255 14.3609C5.21082 14.1209 5.22029 13.8283 5.36725 13.5973L12.3673 2.59734C12.5463 2.31602 12.8895 2.18668 13.2097 2.27991Z",
    fill: "currentColor"
  }
);
export {
  r as default
};
